import { Box } from 'components/universal/box';
import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import { useTranslation } from 'react-i18next';
import cls from './handHotspots.module.scss';
import handImage from 'assets/images/elearning/hand.jpg';
import { ReactComponent as HandImageSVG } from 'assets/images/elearning/hand.svg';

export const HandHotspots = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.inroduction',
    });

    return (
        <Box className={cls.wrapper}>
            <Heading className="mb-5" headingLevel="h2" headingStyle="h5">
                {t('handTitle')}
            </Heading>

            <Paragraph>{t('handDescription')}</Paragraph>

            <div className={cls.imageWrapper}>
                <img src={handImage} />
                <div className={`${cls.bullet} ${cls.bullet1}`}>
                    <p
                        className={`${cls.descriptionBulet} ${cls.descriptionBulet1}`}
                    >
                        POD PAZNOKCIAMI: 10 000 000 – 100 000 000 CFU/cm² <br />
                        Trudno dostępne miejsce przy dezynfekcji rąk. Przestrzeń
                        pod paznokciami zachowuje się jak „schowek” na resztki
                        organiczne, zabrudzenia.
                    </p>
                </div>
                <div className={`${cls.bullet} ${cls.bullet2}`}>
                    <p
                        className={`${cls.descriptionBulet} ${cls.descriptionBulet2}`}
                    >
                        SKÓRKI WOKÓŁ PAZNOKCI: 1 000 000 – 10 000 000 CFU/cm²{' '}
                        <br />
                        Obszar trudno dostępny przy dezynfekcji oraz myciu,
                        sprzyjający namnażaniu patogenów.
                    </p>
                </div>
                <div
                    className={`${cls.bullet} ${cls.bulletOrange} ${cls.bullet3}`}
                >
                    <p
                        className={`${cls.descriptionBulet} ${cls.descriptionBulet3}`}
                    >
                        OPUSZKI PALCÓW: 10 000 – 100 000 CFU/cm² <br />
                        Opuszki palców najczęściej dotykają powierzchni, które
                        mogą być zanieczyszczone. Dodatkowo, oprócz linii
                        papilarnych, w których namnażają się mikroorganizmy,
                        często pojawiają się mikroskopijne szczeliny, poprzez
                        np. zacięcia i uszkodzenia naskórka.
                    </p>
                </div>
                <div
                    className={`${cls.bullet} ${cls.bulletOrange} ${cls.bullet4}`}
                >
                    <p
                        className={`${cls.descriptionBulet} ${cls.descriptionBulet4}`}
                    >
                        PRZESTRZEŃ MIĘDZY PALCAMI: 100 000 – 1 000 000 CFU/cm²{' '}
                        <br />
                        Ciepło pomiędzy palcami oraz wilgoć tam panująca sprzyja
                        rozwojowi drobnoustrojów.
                    </p>
                </div>
                <div
                    className={`${cls.bullet} ${cls.bulletYellow} ${cls.bullet5}`}
                >
                    <p
                        className={`${cls.descriptionBulet} ${cls.descriptionBulet5}`}
                    >
                        WEWNĘTRZNA CZĘŚĆ DŁONI: 10 000 – 100 000 CFU/cm² <br />
                        Wewnętrzna część dłoni jest bogata w bruzdy zgięciowe, które zatrzymują wodę oraz brud, tworząc wilgotne środowisko.
                    </p>
                </div>
                <div
                    className={`${cls.bullet} ${cls.bulletYellow} ${cls.bullet6}`}
                >
                    <p
                        className={`${cls.descriptionBulet} ${cls.descriptionBulet6}`}
                    >
                        GRZBIET DŁONI: 1 000 – 10 000 CFU/cm² <br />
                        Na grzbiecie dłoni posiadamy zazwyczaj suchą skórę, podatną na działanie UV, co może spowalniać namnażanie drobnoustrojów.
                    </p>
                </div>
            </div>

            <p className={cls.subDescription}>{t('handSubDescription')}</p>
        </Box>
    );
};
